import { ColorModeScript } from "@chakra-ui/react";
import * as React from "react";
import ReactDOM from "react-dom";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import "./index.css";
import { GTMProvider } from "@elgorditosalsero/react-gtm-hook";

if (process.env.REACT_APP_BACKEND_ENV === "production") {
  Sentry.init({
    dsn: "https://48639e01f77545f6a9c795b4e3ac9d31@o520511.ingest.sentry.io/5631076",
    integrations: [new Integrations.BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

const gtmParams = {
  id:
    process.env.REACT_APP_BACKEND_ENV === "production"
      ? "GTM-WG3LV66"
      : "GTM-NZN3QDH ",
};

ReactDOM.render(
  <GTMProvider state={gtmParams}>
    <React.StrictMode>
      <ColorModeScript />
      <App />
    </React.StrictMode>
  </GTMProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
